import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { propOr, prop, length, propEq } from 'ramda'
import {
  FEATURE,
  DASH_VIEW,
  LIST,
  SharedVehicleTabs,
  FAST_FEATURES,
} from 'utils/constants'
import { getSerialNumberAndVehicleArea } from 'utils/utils'
import {
  clearFilterTerms,
  clearAllDropdowns,
  clearSearchString,
  resetAllSearch,
} from 'actions/search'
import {
  truckFeaturesUpdated,
  featureUpdateCompleteByVehicleArea,
  addFeatureValidationError,
} from 'actions/truck'
import { clearCreateCollectionNotificaiton } from 'actions/collection'
import { setIsDrawerVisible } from 'actions/drawer'
import {
  getModuleList,
  getTruckDataBySerialNumber,
  getTruckFeatures,
} from 'selectors/truck'
import { getCollectionNotification } from 'selectors/collection'
import { getCanRemoveAsBuiltFeature, hasRight } from 'selectors/authorization'
import { getAuthenticatedModulesForVehicleUpdate } from 'selectors/authorization/checPlus'
import { VIEW_FEATURE_REVISION } from 'constants/authorization'
import {
  createSystemNotification,
  deleteSystemNotification,
} from 'actions/application'
import { setIsModalViewForFeature } from 'actions/feature/features'
import { getSearchResults } from 'selectors/search'
import {
  navigatorIsFullscreen,
  setSelectedIdWithMeta,
  setSelectedIdWithDrawer,
} from 'actions/navigator'

import {
  availableSlotsOnVehicleForSolenoidsSelector,
  solenoidListOnVehicleSelector,
} from 'selectors/ecp'
import { push } from 'connected-react-router'
import { OPTIONAL_SOLENOIDS_EXCEEDED } from 'utils/notifications'
import AddRemoveVehicleFeatures from './AddRemoveVehicleFeatures'

const mapStateToProps = (state, ownProps) => {
  const { serialNumber: vehicleSerial, location } = ownProps
  const appAreaMeta = getSerialNumberAndVehicleArea(location)
  const serialNumber = propOr(vehicleSerial, 'serialNumber', appAreaMeta)
  const vehicleArea = prop('vehicleArea', appAreaMeta)
  const features = getTruckFeatures(state, { serialNumber })
  const searchResults = getSearchResults(state, 'features')
  const fastFeaturesSearchResults = getSearchResults(state, FAST_FEATURES)
  const collectionNotification = getCollectionNotification(state)
  const vehicle = getTruckDataBySerialNumber(serialNumber, state)
  const vehicleSubType = vehicle?.subType

  const vehicleECUs = vehicle?.modules?.filter(propEq('type', 'ecu'))

  const solenoidsOnVehicle = solenoidListOnVehicleSelector(state)
  const availableSlotsOnVehicle =
    availableSlotsOnVehicleForSolenoidsSelector(state)

  return {
    modules: getModuleList(state, { serialNumber }),
    moduleCapacities: vehicle?.modules,
    authenticatedModuleNames: getAuthenticatedModulesForVehicleUpdate(state),
    canRemoveAsBuiltFeature: getCanRemoveAsBuiltFeature(state),
    features,
    serialNumber,
    vehicleArea,
    hasSearchResults:
      Boolean(length(searchResults)) ||
      Boolean(length(fastFeaturesSearchResults)),
    collectionNotification,
    vehicleSubType,
    vehicleECUs,
    solenoidsOnVehicle,
    availableSlotsOnVehicle,
    canViewRevision: hasRight(state, VIEW_FEATURE_REVISION),
  }
}
const mapDispatchToProps = (dispatch, { location }) => ({
  dispatch,
  ...bindActionCreators(
    {
      truckFeaturesUpdated,
      featureUpdateCompleteByVehicleArea,
      createSystemNotification,
      clearAllDropdowns: () => clearAllDropdowns(FEATURE),
      clearFilterTerms: () => clearFilterTerms(FEATURE),
      clearSearchString: () => clearSearchString(FEATURE),
      resetSearch: () => resetAllSearch(FEATURE),
      resetDrawerWidth: () => navigatorIsFullscreen(false),
      setModalViewForFeature: () => setIsModalViewForFeature(),
      apiErrorHandler: () => addFeatureValidationError(),
      clearCreateCollectionNotificaiton,
    },
    dispatch
  ),
  closeDrawer: () => {
    dispatch(setSelectedIdWithDrawer(null))
    if (location.pathname.includes(SharedVehicleTabs.switchandgauge)) {
      dispatch(
        setSelectedIdWithMeta(DASH_VIEW, {
          view: LIST,
          id: '',
        })
      )
    }
    dispatch(setIsDrawerVisible(false))
  },
  goToPneumatics: (serialNumber) => {
    dispatch(
      deleteSystemNotification({ notificationId: OPTIONAL_SOLENOIDS_EXCEEDED })
    )
    dispatch(push(`/vehicles/${serialNumber}/pneumatics`))
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddRemoveVehicleFeatures)
